// Public viewer UI API

// 2D UI Image
function Sculpteo3DViewerImage(viewer, instance, url) {
  this.viewer = viewer;
  this.instance = instance;
  this.url = url;

  // A unique key to keep track of created images
  var key = "";

  for (var i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  this.key = key;
}

Sculpteo3DViewerImage.prototype.destruct = function () {
  if (this.instance) {
    this.viewer._deleteImage(this);
  }
};

// 2D UI Animation
function Sculpteo3DViewerUIAnimation(timeout) {}

Sculpteo3DViewerUIAnimation.prototype.cancel = function () {
  if (typeof this.timeout != "undefined") {
    clearTimeout(this.timeout);
  }
};

// 2D UI Layer
function Sculpteo3DViewerUILayer(viewer, options) {
  if (!viewer) {
    return;
  }

  var viewer_instance = viewer._getViewerInstance();
  var instance = undefined;
  this.classNames = [];

  if (viewer_instance) {
    instance = viewer_instance.createLayer();
  }

  // A unique key to keep track of created layers
  var key = "";

  for (var i = 0; i < 32; i++) {
    key += ((Math.random() * 16) | 0).toString(16);
  }

  this.key = key;

  var data = viewer.$jself.data("viewer");

  if (!data) {
    data = {};
    viewer.$jself.data("viewer", data);
  }

  if (!data["layers"]) {
    data["layers"] = {};
  }

  data["layers"][key] = this;

  // Default options
  var o = {
    backgroundColor: { r: 0, g: 0, b: 0, a: 0 },
    borderColor: { r: 0, g: 0, b: 0, a: 255 },
    borderWidth: 0,
    borderRadius: 0,
    frame: { x: 0.0, y: 0.0, w: 0.0, h: 0.0 },
    interactive: 0,

    // Not supported yet
    opacity: 1.0,
    transform: Matrix.I(3),
    shadowColor: { r: 0, g: 0, b: 0, a: 255 },
    shadowOffset: { x: 0, y: -3.0 },
    shadowRadius: 3.0,
    backgroundTextOffX: 0.0,
    backgroundTextOffY: 0.0,
  };

  if (options) {
    $.extend(true, o, options);
  }

  $.extend(this, o);

  this.viewer = viewer;
  this.instance = instance;
  this.listeners = {};
  this.childLayers = [];

  if (this.instance) {
    viewer._setLayerInteractive(this.instance, this.interactive);
  }

  this._setStyle(this);

  var that = this;

  if (this.highlightStyle) {
    this.addEventListener("mouseenter", function () {
      that.setHighlighted(true);
    });

    this.addEventListener("mouseleave", function () {
      that.setHighlighted(false);
    });
  }
}

Sculpteo3DViewerUILayer.INTERACTIVE_CLICK = 1 << 0;
Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEENTER = 1 << 1;
Sculpteo3DViewerUILayer.INTERACTIVE_MOUSELEAVE = 1 << 2;
Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEDOWN = 1 << 3;
Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEUP = 1 << 4;
Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEMOVE = 1 << 5;

Sculpteo3DViewerUILayer.prototype._updateStyle = function (enabled) {
  if (this.disabled && this.disabledStyle) {
    this._setStyle(this.disabledStyle);
  } else if (this.highlighted && this.highlightStyle) {
    this._setStyle(this.highlightStyle);
  } else {
    this._setStyle(this);
  }
};

Sculpteo3DViewerUILayer.prototype.setHighlighted = function (enabled) {
  this.highlighted = enabled;
  this._updateStyle();
};

Sculpteo3DViewerUILayer.prototype.appendChild = function (child) {
  if (child.parentLayer) {
    child.detach();
  }

  child.parentLayer = this;
  this.childLayers.push(child);

  if (this.instance && child.instance) {
    this.viewer._attachLayer(this.instance, child.instance);
  }
};

Sculpteo3DViewerUILayer.prototype.getParent = function () {
  return this.parentLayer;
};

Sculpteo3DViewerUILayer.prototype.detach = function () {
  if (!this.parentLayer) {
    return;
  }

  if (this.instance) {
    this.viewer._detachLayer(this.instance);
  }

  // Remove from parent children list
  var newList = [];
  var oldList = this.parentLayer.childLayers;

  for (var k = 0; k < oldList.length; k++) {
    if (oldList[k] != this) {
      newList.push(oldList[k]);
    }
  }

  this.parentLayer.childLayers = newList;

  delete this.parentLayer;
};

Sculpteo3DViewerUILayer.prototype.destruct = function () {
  this.detach();

  if (this.instance) {
    this.viewer._deleteLayer(this);
  }
};

Sculpteo3DViewerUILayer.prototype.addClass = function (className) {
  this.classNames.push(className);

  if (this.instance) {
    this.viewer._addLayerClass(this.instance, className);
  }
};

Sculpteo3DViewerUILayer.prototype.setZIndex = function (zIndex) {
  this.zIndex = zIndex;

  if (this.instance) {
    this.viewer._setZIndex(this.instance, zIndex);
  }
};

Sculpteo3DViewerUILayer.prototype.setFrame = function (x, y, w, h) {
  if (typeof w == "undefined") {
    w = this.frame.w;
  }

  if (typeof h == "undefined") {
    h = this.frame.h;
  }

  this.frame = { x: x, y: y, w: w, h: h };

  if (this.instance) {
    this.viewer._setLayerFrame(this.instance, x, y, w, h);
  }
};

Sculpteo3DViewerUILayer.prototype.setBorderColor = function (r, g, b, a) {
  this.borderColor = { r: r, g: g, b: b, a: a };

  if (this.instance) {
    this.viewer._setLayerBorderColor(this.instance, r, g, b, a);
  }
};

Sculpteo3DViewerUILayer.prototype.setBorderWidth = function (width) {
  this.borderWidth = parseInt(width);

  if (this.instance) {
    this.viewer._setLayerBorderWidth(this.instance, this.borderWidth);
  }
};

Sculpteo3DViewerUILayer.prototype.setBorderRadius = function (radius) {
  this.borderRadius = parseInt(radius);

  if (this.instance) {
    this.viewer._setLayerBorderRadius(this.instance, this.borderRadius);
  }
};

Sculpteo3DViewerUILayer.prototype.setBackgroundColor = function (r, g, b, a) {
  this.backgroundColor = { r: r, g: g, b: b, a: a };

  if (this.instance) {
    this.viewer._setLayerBackgroundColor(this.instance, r, g, b, a);
  }
};

Sculpteo3DViewerUILayer.prototype.setBackgroundImage = function (
  image,
  offx,
  offy
) {
  if (typeof offx == "undefined") {
    offx = 0;
  }

  if (typeof offy == "undefined") {
    offy = 0;
  }

  if (image) {
    this.backgroundOffX = offx;
    this.backgroundOffY = offy;
    this.backgroundImage = image;
  } else {
    delete this.backgroundImage;
  }

  if (this.instance) {
    this.viewer._setLayerBackgroundImage(
      this.instance,
      image ? image.instance : null,
      offx,
      offy
    );
  }
};

Sculpteo3DViewerUILayer.prototype.setBackgroundText = function (
  font,
  str,
  color,
  offx,
  offy
) {
  if (typeof font != "undefined") {
    this.backgroundTextFont = font;
  }

  if (typeof offx != "undefined") {
    this.backgroundTextOffX = offx;
  }

  if (typeof offy != "undefined") {
    this.backgroundTextOffY = offy;
  }

  if (typeof str != "undefined") {
    this.backgroundTextString = str;
  }

  if (typeof color != "undefined") {
    this.backgroundTextColor = color;
  }

  if (this.instance) {
    this.viewer._setLayerBackgroundText(
      this.instance,
      this.backgroundTextFont,
      this.backgroundTextString,
      this.backgroundTextColor,
      this.backgroundTextOffX,
      this.backgroundTextOffY
    );
  }
};

Sculpteo3DViewerUILayer.prototype.setOpacity = function (opacity) {
  this.opacity = opacity;

  if (this.instance) {
    this.viewer._setLayerOpacity(this.instance, opacity);
  }
};

Sculpteo3DViewerUILayer.prototype._setStyle = function (style) {
  if (!this.instance) {
    return;
  }

  if (style.frame) {
    this.viewer._setLayerFrame(
      this.instance,
      style.frame.x,
      style.frame.y,
      style.frame.w,
      style.frame.h
    );
  }

  if (style.backgroundColor) {
    this.viewer._setLayerBackgroundColor(
      this.instance,
      style.backgroundColor.r,
      style.backgroundColor.g,
      style.backgroundColor.b,
      style.backgroundColor.a
    );
  }

  if (style.backgroundImage) {
    this.viewer._setLayerBackgroundImage(
      this.instance,
      style.backgroundImage.instance,
      style.backgroundOffX,
      style.backgroundOffY
    );
  }

  if (
    style.backgroundTextFont ||
    style.backgroundTextString ||
    style.backgroundTextColor ||
    style.backgroundTextOffX ||
    style.backgroundTextOffY
  ) {
    this.viewer._setLayerBackgroundText(
      this.instance,
      style.backgroundTextFont || this.backgroundTextFont,
      style.backgroundTextString || this.backgroundTextString,
      style.backgroundTextColor || this.backgroundTextColor,
      style.backgroundTextOffX || this.backgroundTextOffX,
      style.backgroundTextOffY || this.backgroundTextOffY
    );
  }

  if (style.borderColor) {
    this.viewer._setLayerBorderColor(
      this.instance,
      style.borderColor.r,
      style.borderColor.g,
      style.borderColor.b,
      style.borderColor.a
    );
  }

  if (style.borderWidth) {
    this.viewer._setLayerBorderWidth(
      this.instance,
      parseInt(style.borderWidth, 10)
    );
  }

  if (style.borderRadius) {
    this.viewer._setLayerBorderRadius(
      this.instance,
      parseInt(style.borderRadius, 10)
    );
  }

  if (typeof style.opacity != "undefined") {
    this.viewer._setLayerOpacity(this.instance, style.opacity);
  }
  if (typeof style.classNames !== "undefined") {
    for (var i = 0; i < style.classNames.length; i++) {
      this.viewer._addLayerClass(this.instance, style.classNames[i]);
    }
  }
};

Sculpteo3DViewerUILayer.prototype.animate = function (
  style,
  duration,
  easing,
  done
) {
  // Reuse easing functions from jQuery
  if (!easing) {
    easing = "swing";
  }

  if (typeof easing != "function") {
    easing = $.easing[easing];
  }

  var time1 = +new Date();
  var srcStyle = $.extend(true, {}, this); // Deep copy of current style
  var dstStyle = $.extend(false, {}, srcStyle); // Shallow copy and overwrite

  $.extend(dstStyle, style);
  var that = this;
  var animation = new Sculpteo3DViewerUIAnimation();
  var anim = function () {
    var time2 = +new Date();
    var percent = (time2 - time1) / duration;

    if (percent > 1.0) {
      percent = 1.0;
    }

    var v = easing(percent, duration * percent, 0, 1, duration);

    if (srcStyle.frame != dstStyle.frame) {
      that.setFrame(
        (1.0 - v) * srcStyle.frame.x + v * dstStyle.frame.x,
        (1.0 - v) * srcStyle.frame.y + v * dstStyle.frame.y,
        (1.0 - v) * srcStyle.frame.w + v * dstStyle.frame.w,
        (1.0 - v) * srcStyle.frame.h + v * dstStyle.frame.h
      );
    }

    if (srcStyle.backgroundColor != dstStyle.backgroundColor) {
      that.setBackgroundColor(
        (1.0 - v) * srcStyle.backgroundColor.r + v * dstStyle.backgroundColor.r,
        (1.0 - v) * srcStyle.backgroundColor.g + v * dstStyle.backgroundColor.g,
        (1.0 - v) * srcStyle.backgroundColor.b + v * dstStyle.backgroundColor.b,
        (1.0 - v) * srcStyle.backgroundColor.a + v * dstStyle.backgroundColor.a
      );
    }

    if (srcStyle.borderColor != dstStyle.borderColor) {
      that.setBorderColor(
        (1.0 - v) * srcStyle.borderColor.r + v * dstStyle.borderColor.r,
        (1.0 - v) * srcStyle.borderColor.g + v * dstStyle.borderColor.g,
        (1.0 - v) * srcStyle.borderColor.b + v * dstStyle.borderColor.b,
        (1.0 - v) * srcStyle.borderColor.a + v * dstStyle.borderColor.a
      );
    }

    if (srcStyle.borderWidth != dstStyle.borderWidth) {
      that.setBorderWidth(
        (1.0 - v) * srcStyle.borderWidth + v * dstStyle.borderWidth
      );
    }

    if (srcStyle.borderRadius != dstStyle.borderRadius) {
      that.setBorderRadius(
        (1.0 - v) * srcStyle.borderRadius + v * dstStyle.borderRadius
      );
    }

    if (srcStyle.opacity != dstStyle.opacity) {
      that.setOpacity((1.0 - v) * srcStyle.opacity + v * dstStyle.opacity);
    }

    if (percent < 1.0) {
      animation.timeout = setTimeout(anim, 16);
    } else if (typeof done == "function") {
      done.call(this);
    }
  };

  animation.timeout = setTimeout(anim);

  return animation;
};

Sculpteo3DViewerUILayer.prototype.fadeOut = function (duration, done) {
  return this.animate({ opacity: 0.0 }, duration, undefined, done);
};

Sculpteo3DViewerUILayer.prototype.addEventListener = function (
  eventname,
  callback
) {
  if (typeof eventname == "object" && typeof eventname.length != "undefined") {
    // Support binding multiple events to the same function
    for (var i = 0; i < eventname.length; i++) {
      this.addEventListener(eventname[i], callback);
    }

    return;
  }

  var a = eventname.split(".");
  var ename = a[0];
  var subname = a[1];

  if (!this.listeners[ename]) {
    this.listeners[ename] = [];
  }

  if (this.listeners[ename].length == 0) {
    switch (ename) {
      case "click":
        this.interactive |= Sculpteo3DViewerUILayer.INTERACTIVE_CLICK;
        break;
      case "mouseenter":
        this.interactive |= Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEENTER;
        break;
      case "mouseleave":
        this.interactive |= Sculpteo3DViewerUILayer.INTERACTIVE_MOUSELEAVE;
        break;
      case "mousedown":
        this.interactive |= Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEDOWN;
        break;
      case "mouseup":
        this.interactive |= Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEUP;
        break;
      case "mousemove":
        this.interactive |= Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEMOVE;
        break;
    }

    if (this.instance) {
      this.viewer._setLayerInteractive(this.instance, this.interactive);
    }
  }

  var d = { fn: callback };

  if (subname) {
    d.subname = subname;
  }

  this.listeners[ename].push(d);

  if (this.instance) {
    this.viewer._mapLayerEvent(this.instance, this);
  }
};

Sculpteo3DViewerUILayer.prototype.removeEventListener = function (
  eventname,
  callback
) {
  if (typeof eventname == "object" && typeof eventname.length != "undefined") {
    // Support unbinding multiple events
    for (var i = 0; i < eventname.length; i++) {
      this.removeEventListener(eventname[i], callback);
    }

    return;
  }

  var a = eventname.split(".");
  var ename = a[0];
  var subname = a[1];

  if (!this.listeners[ename]) {
    this.listeners[ename] = [];
  }

  var l = [];

  if (callback || subname) {
    for (var k = 0; k < this.listeners[ename].length; k++) {
      if (callback && this.listeners[ename][k].fn == callback) {
        continue;
      }

      if (subname && this.listeners[ename][k].subname == subname) {
        continue;
      }

      l.push(this.listeners[ename][k]);
    }
  }

  this.listeners[ename] = l;

  if (l.length == 0) {
    switch (ename) {
      case "click":
        this.interactive &= ~Sculpteo3DViewerUILayer.INTERACTIVE_CLICK;
        break;
      case "mouseenter":
        this.interactive &= ~Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEENTER;
        break;
      case "mouseleave":
        this.interactive &= ~Sculpteo3DViewerUILayer.INTERACTIVE_MOUSELEAVE;
        break;
      case "mousedown":
        this.interactive &= ~Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEDOWN;
        break;
      case "mouseup":
        this.interactive &= ~Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEUP;
        break;
      case "mousemove":
        this.interactive &= ~Sculpteo3DViewerUILayer.INTERACTIVE_MOUSEMOVE;
        break;
    }

    if (this.instance) {
      this.viewer._setLayerInteractive(this.instance, this.interactive);
    }
  }
};

Sculpteo3DViewerUILayer.prototype.dispatchEvent = function (
  layer_event,
  layer_event_args
) {
  var b = !(layer_event == "mouseenter" || layer_event == "mouseleave"); // Bubble up?

  if (this.listeners && this.listeners[layer_event]) {
    var c = this.listeners[layer_event];

    for (var i = 0; i < c.length; i++) {
      var f = c[i].fn;

      if (typeof f == "function") {
        b = f.apply(this, layer_event_args) != false && b;
      }
    }
  }

  if (b && this.parentLayer) {
    this.parentLayer.dispatchEvent(layer_event, layer_event_args);
  }
};

Sculpteo3DViewerUILayer.prototype.bind =
  Sculpteo3DViewerUILayer.prototype.addEventListener;
Sculpteo3DViewerUILayer.prototype.unbind =
  Sculpteo3DViewerUILayer.prototype.removeEventListener;

Sculpteo3DViewerUILayer.prototype.click = function (callback) {
  if (typeof callback == "function") {
    this.addEventListener("click", callback);
  } else {
    this.dispatchEvent("click", arguments);
  }
};

Sculpteo3DViewerUILayer.prototype.mouseenter = function (callback) {
  this.addEventListener("mouseenter", callback);
};

Sculpteo3DViewerUILayer.prototype.mouseleave = function (callback) {
  this.addEventListener("mouseleave", callback);
};

Sculpteo3DViewerUILayer.prototype.mousedown = function (callback) {
  this.addEventListener("mousedown", callback);
};

Sculpteo3DViewerUILayer.prototype.mouseup = function (callback) {
  this.addEventListener("mouseup", callback);
};

Sculpteo3DViewerUILayer.prototype.mousemove = function (callback) {
  this.addEventListener("mousemove", callback);
};

// 2D UI label
Sculpteo3DViewerUILabel.prototype = new Sculpteo3DViewerUILayer();

function Sculpteo3DViewerUILabel(viewer, options) {
  var o = {
    font: "arial",
    fontWeight: "",
    textHeight: 20,
    textColor: { r: 255, g: 255, b: 255, a: 255 },
    text: "",
  };

  $.extend(o, options);
  $.extend(this, o);

  Sculpteo3DViewerUILayer.call(this, viewer, o);

  this.setText(this.text);
}

// http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
Sculpteo3DViewerUILabel.prototype._getTextMetrics = function (str, font) {
  var f = font,
    o = $("<div>" + str + "</div>")
      .css({
        position: "absolute",
        float: "left",
        "white-space": "nowrap",
        visibility: "hidden",
        font: f,
      })
      .appendTo($("body")),
    w = o.width(),
    h = o.height();

  o.remove();

  return { width: w, height: h };
};

Sculpteo3DViewerUILabel.prototype.setText = function (str, options) {
  if (options) {
    if (options.font) {
      this.font = options.font;
    }

    if (options.textHeight) {
      this.textHeight = options.textHeight;
    }

    if (options.fontWeight) {
      this.fontWeight = options.fontWeight;
    }

    if (options.textColor) {
      this.textColor = options.textColor;
    }
  }

  this.text = str;

  var fullfont = this.fontWeight + " " + this.textHeight + "px " + this.font;

  var width, height;
  var metrics = this._getTextMetrics(this.text, fullfont);

  width = metrics.width + 2; // Add some margin
  height = metrics.height + 2;
  this.setFrame(this.frame.x, this.frame.y, width, height);
  this.setBackgroundText(fullfont, this.text, this.textColor, 0, 0);
};

// 2D UI button
Sculpteo3DViewerUIButton.prototype = new Sculpteo3DViewerUILayer();

function Sculpteo3DViewerUIButton(viewer, options) {
  var o = {
    font: "arial",
    fontWeight: "",
    textHeight: 20,
    textColor: { r: 255, g: 255, b: 255, a: 255 },
    backgroundColor: { r: 0, g: 0, b: 0, a: 192 },
    highlightStyle: { backgroundColor: { r: 64, g: 64, b: 64, a: 192 } },
    borderColor: { r: 0, g: 0, b: 32, a: 255 },
    borderWidth: 1,
    borderRadius: 4,
    margin: 6,
    text: "",
  };

  $.extend(o, options);
  $.extend(this, o);

  Sculpteo3DViewerUILayer.call(this, viewer, o);

  // Create text
  if (this.text) {
    this.textLayer = viewer.createUILabel({
      font: this.font,
      fontWeight: this.fontWeight,
      textHeight: this.textHeight,
      text: this.text,
      textColor: this.textColor,
    });
    var m = ("" + this.margin).split(" ");

    if (m.length > 1) {
      this.margin_y = parseFloat(m[1]);
    } else {
      this.margin_y = parseFloat(m[0]);
    }

    this.margin_x = parseFloat(m[0]);
    this.textLayer.setFrame(
      this.margin_x,
      this.margin_y,
      this.textLayer.frame.w,
      this.textLayer.frame.h
    );

    // Set dimensions
    this.setFrame(
      0,
      0,
      this.textLayer.frame.w + 2 * this.margin_x,
      this.textLayer.frame.h + 2 * this.margin_y
    );

    // Append text
    this.appendChild(this.textLayer);
  }

  this.disabled = false;
}

Sculpteo3DViewerUIButton.prototype.setText = function (str, options) {
  var f = this.textLayer.frame;
  var r = this.textLayer.setText(str, options);

  this.textLayer.setFrame(f.x, f.y);

  this.setFrame(
    this.frame.x,
    this.frame.y,
    this.textLayer.frame.w + 2 * this.margin_x,
    this.textLayer.frame.h + 2 * this.margin_y
  );

  return r;
};

Sculpteo3DViewerUIButton.prototype._setStyle = function (options) {
  var o = {};

  $.extend(o, options);

  var s = {};
  var keys = ["font", "fontWeight", "textHeight", "textColor"];

  for (var i in keys) {
    var k = keys[i];

    if (o[k]) {
      s[k] = o[k];
      delete o[k];
    }
  }

  if (this.textLayer) {
    this.setText(this.text, s);
  }

  Sculpteo3DViewerUILayer.prototype._setStyle.call(this, o);
};

Sculpteo3DViewerUIButton.prototype.setDisabled = function (disabled) {
  this.disabled = disabled;
  this._updateStyle();
};

// 2D UI ToggleButton

Sculpteo3DViewerUIToggleButton.prototype = new Sculpteo3DViewerUIButton();

function Sculpteo3DViewerUIToggleButton(viewer, options) {
  var o = {
    checked: false,
    checkedStyle: { backgroundColor: { r: 64, g: 64, b: 128, a: 192 } },
  };

  $.extend(o, options);
  $.extend(this, o);

  Sculpteo3DViewerUIButton.call(this, viewer, o);

  var that = this;

  this.click(function (event) {
    that.setChecked(!that.checked);
  });
}

Sculpteo3DViewerUIToggleButton.prototype._updateStyle = function (enabled) {
  if (this.disabled && this.disabledStyle) {
    this._setStyle(this.disabledStyle);
  } else if (this.highlighted && this.highlightStyle) {
    this._setStyle(this.highlightStyle);
  } else {
    if (this.checked && this.checkedStyle) {
      this._setStyle(this.checkedStyle);
    } else {
      this._setStyle(this);
    }
  }
};

Sculpteo3DViewerUIToggleButton.prototype.setChecked = function (enabled) {
  this.checked = enabled;
  this._updateStyle();
};

// 2D UI slider
Sculpteo3DViewerUISlider.prototype = new Sculpteo3DViewerUILayer();

function Sculpteo3DViewerUISlider(viewer, options) {
  var o = {
    handleStyle: {
      backgroundColor: { r: 0, g: 128, b: 196, a: 255 },
      borderColor: { r: 0, g: 0, b: 64, a: 255 },
      borderRadius: 4,
      borderWidth: 1,
      frame: { x: 0, y: 0, w: 8, h: 14 },
      highlightStyle: {
        backgroundColor: { r: 0, g: 196, b: 255, a: 255 },
      },
    },
    sliderStyle: {
      backgroundColor: { r: 255, g: 255, b: 255, a: 255 },
      borderColor: { r: 192, g: 192, b: 192, a: 255 },
      borderWidth: 1,
      borderRadius: 4,
      frame: { x: 0, y: 0, w: 4, h: 4 },
    },
    sliderFillStyle: {
      backgroundColor: { r: 0, g: 128, b: 196, a: 255 },
      borderColor: { r: 192, g: 192, b: 192, a: 255 },
      borderWidth: 1,
      borderRadius: 4,
    },
    orientation: "horizontal",
    value: 0.0,
  };

  if (options && options["orientation"] == "vertical") {
    var tmp = o.handleStyle.frame.w;

    o.handleStyle.frame.w = o.handleStyle.frame.h;
    o.handleStyle.frame.h = tmp;
  }

  $.extend(o, options);
  $.extend(this, o);

  Sculpteo3DViewerUILayer.call(this, viewer, o);

  // Create slider & handle
  this.sliderLayer = viewer.createUILayer(this.sliderStyle);
  this.sliderFillLayer = viewer.createUILayer(this.sliderFillStyle);
  this.handleLayer = viewer.createUILayer(this.handleStyle);

  if (this.orientation == "horizontal") {
    this.sliderLayer.setFrame(
      0.5 * this.handleStyle.frame.w,
      0.5 * (this.frame.h - this.sliderStyle.frame.h) -
        this.sliderStyle.borderWidth,
      this.frame.w - this.handleStyle.frame.w,
      this.sliderStyle.frame.h
    );
    this.sliderFillLayer.setFrame(
      0.5 * this.handleStyle.frame.w,
      0.5 * (this.frame.h - this.sliderStyle.frame.h) -
        this.sliderStyle.borderWidth,
      this.value * this.frame.w - 0.5 * this.handleStyle.frame.w,
      this.sliderStyle.frame.h
    );
    this.handleLayer.setFrame(
      this.value * this.frame.w - this.handleStyle.borderWidth,
      0.5 *
        (this.frame.h -
          this.handleStyle.frame.h -
          2 * this.handleStyle.borderWidth),
      this.handleStyle.frame.w,
      this.handleStyle.frame.h
    );
  } else {
    this.sliderLayer.setFrame(
      0.5 * (this.frame.w - this.sliderStyle.frame.w) -
        this.sliderStyle.borderWidth,
      0.5 * this.handleStyle.frame.h,
      this.sliderStyle.frame.w,
      this.frame.h - this.handleStyle.frame.h
    );
    this.sliderFillLayer.setFrame(
      0.5 * (this.frame.w - this.sliderStyle.frame.w) -
        this.sliderStyle.borderWidth,
      (1.0 - this.value) * this.frame.h + 0.5 * this.handleStyle.frame.h,
      this.sliderStyle.frame.w,
      this.value * this.frame.h + 0.5 * this.handleStyle.frame.h
    );
    this.handleLayer.setFrame(
      0.5 *
        (this.frame.w -
          this.handleStyle.frame.w -
          2 * this.handleStyle.borderWidth),
      (1.0 - this.value) * this.frame.h - this.handleStyle.borderWidth,
      this.handleStyle.frame.w,
      this.handleStyle.frame.h
    );
  }

  // Append slider & handle
  this.appendChild(this.sliderLayer);
  this.appendChild(this.sliderFillLayer);
  this.appendChild(this.handleLayer);

  // Ensure value is a float
  this.value = parseFloat(this.value);

  // Handle drag events
  var that = this;

  this.handleLayer.addEventListener("mousedown", function (x, y) {
    that.handleDragStart = { x: x, y: y, value: that.value };
  });

  var root = viewer.getRootLayer();

  root.addEventListener("mouseup", function (x, y) {
    if (!that.handleDragStart) {
      return;
    }

    that.dispatchEvent("stop");
    delete that.handleDragStart;
  });

  root.addEventListener("mousemove", function (x, y) {
    if (!that.handleDragStart) {
      return;
    }

    var delta, value;

    if (that.orientation == "horizontal") {
      delta =
        (x - that.handleDragStart.x) /
        (that.frame.w - that.handleStyle.frame.w);
    } else {
      delta =
        -(y - that.handleDragStart.y) /
        (that.frame.h - -that.handleStyle.frame.h);
    }

    var value = that.handleDragStart.value + delta;

    that.setValue(value);
    that.dispatchEvent("slide");
  });

  // Click on slider to set value
  this.handleLayer.addEventListener("click", function (x, y, ox, oy) {
    // Ignore clicks on handle
    return false;
  });

  this.sliderLayer.addEventListener("click", function (x, y, ox, oy) {
    var value;

    if (that.orientation == "horizontal") {
      value = (parseFloat(x) - parseFloat(ox)) / that.sliderLayer.frame.w;
    } else {
      value = 1.0 - (parseFloat(y) - parseFloat(oy)) / that.sliderLayer.frame.h;
    }

    that.setValue(value);
    that.dispatchEvent("stop");
  });

  this.sliderFillLayer.addEventListener("click", function (x, y, ox, oy) {
    var value;

    if (that.orientation == "horizontal") {
      value = (parseFloat(x) - parseFloat(ox)) / that.sliderLayer.frame.w;
    } else {
      value =
        (parseFloat(oy) + that.sliderFillLayer.frame.h - parseFloat(y)) /
        that.sliderLayer.frame.h;
    }

    that.setValue(value);
    that.dispatchEvent("stop");
  });
}

Sculpteo3DViewerUISlider.prototype.setFrame = function (x, y, w, h) {
  Sculpteo3DViewerUILayer.prototype.setFrame.call(this, x, y, w, h);

  if (this.orientation == "horizontal") {
    this.sliderLayer.setFrame(
      0.5 * this.handleStyle.frame.w,
      0.5 * (this.frame.h - this.sliderStyle.frame.h) -
        this.sliderStyle.borderWidth,
      w - 2 * this.sliderStyle.borderWidth - this.handleStyle.frame.w,
      this.sliderStyle.frame.h
    );
    this.sliderFillLayer.setFrame(
      0.5 * this.handleStyle.frame.w,
      0.5 * (this.frame.h - this.sliderStyle.frame.h) -
        this.sliderStyle.borderWidth,
      this.value * this.frame.w - 0.5 * this.handleStyle.frame.w,
      this.sliderStyle.frame.h
    );
    this.handleLayer.setFrame(
      this.value * this.frame.w - this.handleStyle.borderWidth,
      0.5 *
        (this.frame.h -
          this.handleStyle.frame.h -
          2 * this.handleStyle.borderWidth),
      this.handleStyle.frame.w,
      this.handleStyle.frame.h
    );
  } else {
    this.sliderLayer.setFrame(
      0.5 * (this.frame.w - this.sliderStyle.frame.w) -
        this.sliderStyle.borderWidth,
      0.5 * this.handleStyle.frame.h,
      this.sliderStyle.frame.w,
      h - 2 * this.sliderStyle.borderWidth - this.handleStyle.frame.h
    );
    this.sliderFillLayer.setFrame(
      0.5 * (this.frame.w - this.sliderStyle.frame.w) -
        this.sliderStyle.borderWidth,
      (1.0 - this.value) * this.frame.h + 0.5 * this.handleStyle.frame.h,
      this.sliderStyle.frame.w,
      this.value * this.frame.h + 0.5 * this.handleStyle.frame.h
    );
    this.handleLayer.setFrame(
      0.5 *
        (this.frame.w -
          this.handleStyle.frame.w -
          2 * this.handleStyle.borderWidth),
      (1.0 - this.value) * this.frame.h - this.handleStyle.borderWidth,
      this.handleStyle.frame.w,
      this.handleStyle.frame.h
    );
  }
};

Sculpteo3DViewerUISlider.prototype.setValue = function (value) {
  this.value = value;

  if (this.value < 0.0) {
    this.value = 0.0;
  }

  if (this.value > 1.0) {
    this.value = 1.0;
  }

  if (this.orientation == "horizontal") {
    this.handleLayer.setFrame(
      this.value *
        (this.frame.w -
          2 * this.handleStyle.borderWidth -
          this.handleStyle.frame.w),
      0.5 *
        (this.frame.h -
          this.handleStyle.frame.h -
          2 * this.handleStyle.borderWidth)
    );
    this.sliderFillLayer.setFrame(
      0.5 * this.handleStyle.frame.w,
      0.5 * (this.frame.h - this.sliderStyle.frame.h) -
        this.sliderStyle.borderWidth,
      this.value *
        (this.frame.w -
          2 * this.handleStyle.borderWidth -
          this.handleStyle.frame.w),
      this.sliderStyle.frame.h
    );
  } else {
    this.handleLayer.setFrame(
      0.5 *
        (this.frame.w -
          this.handleStyle.frame.w -
          2 * this.handleStyle.borderWidth),
      (1.0 - this.value) *
        (this.frame.h -
          2 * this.handleStyle.borderWidth -
          this.handleStyle.frame.h)
    );
    this.sliderFillLayer.setFrame(
      0.5 * (this.frame.w - this.sliderStyle.frame.w) -
        this.sliderStyle.borderWidth,
      (1.0 - this.value) *
        (this.frame.h -
          2 * this.handleStyle.borderWidth -
          this.handleStyle.frame.h) +
        0.5 * this.handleStyle.frame.h +
        this.handleStyle.borderWidth,
      this.sliderStyle.frame.w,
      this.value *
        (this.frame.h -
          2 * this.handleStyle.borderWidth -
          this.handleStyle.frame.h)
    );
  }
};

// 2D UI alert
Sculpteo3DViewerUIAlert.prototype = new Sculpteo3DViewerUILayer();

function Sculpteo3DViewerUIAlert(viewer, options) {
  var that = this;
  var o = {
    font: "arial",
    titleWeight: "",
    titleHeight: 20,
    textWeight: "",
    textHeight: 16,
    textColor: { r: 255, g: 255, b: 255, a: 255 },
    backgroundColor: { r: 0, g: 32, b: 64, a: 192 },
    borderColor: { r: 204, g: 204, b: 221, a: 255 },
    borderRadius: 10,
    borderWidth: 3,
    margin: 6,
    title: "",
    text: "",
  };

  $.extend(o, options);
  $.extend(this, o);

  Sculpteo3DViewerUILayer.call(this, viewer, o);

  this.titleLayer = viewer.createUILabel({
    font: this.font,
    fontWeight: this.titleWeight,
    textHeight: this.titleHeight,
    text: this.title,
    textColor: this.textColor,
  });

  this.textLayer = viewer.createUILabel({
    font: this.font,
    fontWeight: this.textWeight,
    textHeight: this.textHeight,
    text: this.text,
    textColor: this.textColor,
  });

  // Create button
  this.buttonLayer = viewer.createUIButton({
    text: "Ok",
    font: this.font,
    backgroundColor: { r: 255, g: 255, b: 255, a: 64 },
    highlightStyle: { backgroundColor: { r: 128, g: 128, b: 128, a: 192 } },
  });
  this.buttonLayer.click(function () {
    that.destruct();
  });

  // Set dimensions
  this.setFrame(
    0,
    0,
    2 * this.margin +
      Math.max(
        Math.max(this.titleLayer.frame.w, this.textLayer.frame.w),
        this.buttonLayer.frame.w
      ),
    6 * this.margin +
      this.titleLayer.frame.h +
      this.textLayer.frame.h +
      this.buttonLayer.frame.h
  );

  this.titleLayer.setFrame(
    0.5 * (this.frame.w - this.titleLayer.frame.w),
    this.margin
  );
  this.textLayer.setFrame(
    0.5 * (this.frame.w - this.textLayer.frame.w),
    3 * this.margin + this.titleLayer.frame.h
  );
  this.buttonLayer.setFrame(
    0.5 * (this.frame.w - this.buttonLayer.frame.w),
    5 * this.margin + this.titleLayer.frame.h + this.textLayer.frame.h
  );

  // Append
  this.appendChild(this.titleLayer);
  this.appendChild(this.textLayer);
  this.appendChild(this.buttonLayer);
}

// 2D Menu
Sculpteo3DViewerUIMenu.prototype = new Sculpteo3DViewerUILayer();

function Sculpteo3DViewerUIMenu(viewer, options) {
  var that = this;
  var o = {
    font: "arial",
    items: [],
    selectionColor: { r: 106, g: 164, b: 245, a: 255 },
    backgroundColor: { r: 0, g: 0, b: 0, a: 128 },
    borderColor: { r: 0, g: 0, b: 0, a: 255 },
    borderWidth: 1,
    borderRadius: 0,
    fontWeight: "",
    textHeight: 14,
    textColor: { r: 255, g: 255, b: 255, a: 255 },
    margin: 4,
    frame: { x: 0, y: 0, w: 0, h: 0 },
  };

  $.extend(o, options);
  $.extend(this, o);

  var itemHeight = o.textHeight + 2 * o.margin;
  var menuHeight = o.items.length * itemHeight;
  var menuWidth = o.frame.w;

  o.frame.h = menuHeight;

  Sculpteo3DViewerUILayer.call(this, viewer, o);

  // We don't want to copy this as we are going to
  // patch the items to add a setAccessory function
  this.items = options.items;

  this.containers = [];

  for (var i = 0; i < this.items.length; i++) {
    // Label for item title
    var menuLabel = viewer.createUILabel({
      font: this.font,
      fontWeight: this.fontWeight,
      textHeight: this.textHeight,
      text: this.items[i].title,
      textColor: this.textColor,
    });

    // Container to highlight on selection
    var menuLabelContainer = viewer.createUILayer({
      backgroundColor: { r: 0, g: 0, b: 0, a: 0 },
    });

    menuLabel.setFrame(2 * this.margin, this.margin);
    menuLabelContainer.setFrame(0, itemHeight * i, menuWidth, itemHeight);
    menuLabelContainer.appendChild(menuLabel);
    menuLabelContainer.item = this.items[i];

    if (menuLabelContainer.item.items) {
      var o = $.extend({}, options);

      menuLabelContainer.submenu = viewer.createUIMenu(
        $.extend(o, {
          items: this.items[i].items,
        })
      );
      menuLabelContainer.submenu.parentMenu = that;

      // Empty click listener so that root layer click is not called
      menuLabelContainer.click(function () {});

      // Add an arrow at the end of the row, which must be the first accessory
      if (this.accessoryImage) {
        menuAccessory = viewer.createUILayer({
          backgroundImage: this.accessoryImage,
          backgroundOffX: 0,
          backgroundOffY: -16,
          frame: {
            x: menuWidth - this.margin - 16,
            y: (itemHeight - 16) / 2,
            w: 16,
            h: 16,
          },
        });
        menuLabelContainer.appendChild(menuAccessory);
      }
    } else {
      if (menuLabelContainer.item.action) {
        menuLabelContainer.click(function () {
          // Call item action
          this.item.action.call(this.item);

          // Close menu
          var rootMenu = that;

          rootMenu.detach();

          while (rootMenu.parentMenu) {
            rootMenu = rootMenu.parentMenu;
            rootMenu.detach();
          }
        });
      }

      // Add accessory at the end of the row
      if (
        this.accessoryImage &&
        typeof menuLabelContainer.item.accessory != "undefined"
      ) {
        menuAccessory = viewer.createUILayer({
          backgroundImage: this.accessoryImage,
          backgroundOffX: 0,
          backgroundOffY: -menuLabelContainer.item.accessory * 16,
          frame: {
            x: menuWidth - this.margin - 16,
            y: (itemHeight - 16) / 2,
            w: 16,
            h: 16,
          },
        });
        menuLabelContainer.appendChild(menuAccessory);

        // Add function to menu item to allow it to change its accessory
        menuLabelContainer.item._menuAccessory = menuAccessory;
        menuLabelContainer.item.setAccessory = function (accessory) {
          this.accessory = accessory;
          this._menuAccessory.setBackgroundImage(
            that.accessoryImage,
            0,
            -accessory * 16
          );
        };
      }
    }

    menuLabelContainer.addEventListener("mouseenter", function () {
      for (var k = 0; k < that.containers.length; k++) {
        var container = that.containers[k];

        // Close all other submenus
        if (container.submenu) {
          container.submenu.detach();
        }

        // Clear selection color of other items
        container._setStyle({
          backgroundColor: { r: 0, g: 0, b: 0, a: 0 },
        });
      }

      // Set selection color
      this._setStyle({
        backgroundColor: that.selectionColor,
      });

      // Show our own submenu if we have one
      if (this.submenu && that.parentLayer) {
        that.parentLayer.appendChild(this.submenu);
      }
    });

    // Append container
    this.appendChild(menuLabelContainer);

    this.containers.push(menuLabelContainer);
  }
}

Sculpteo3DViewerUIMenu.prototype.setFrame = function (x, y, w, h) {
  Sculpteo3DViewerUILayer.prototype.setFrame.call(this, x, y, w, h);

  // Update position of submenus
  for (var k = 0; k < this.containers.length; k++) {
    var container = this.containers[k];

    if (container.submenu) {
      var yoffset = container.frame.y;
      var xoffset = container.frame.w;

      container.submenu.setFrame(x + xoffset, y + yoffset);
    }
  }
};

Sculpteo3DViewerUIMenu.prototype.detach = function () {
  Sculpteo3DViewerUILayer.prototype.detach.call(this);

  // Detach all submenus
  for (var k = 0; k < this.containers.length; k++) {
    var container = this.containers[k];

    if (container.submenu) {
      container.submenu.detach();
    }
  }
};

// 2D UI activity indicator
Sculpteo3DViewerUIThrobber.prototype = new Sculpteo3DViewerUILayer();

function Sculpteo3DViewerUIThrobber(viewer, options) {
  var that = this;
  var o = {
    animationImage: null,
    animationFrames: 12,
    fps: 24,
    animating: false,
  };

  $.extend(o, options);
  $.extend(this, o);

  Sculpteo3DViewerUILayer.call(this, viewer, o);

  if (this.animating) {
    this.animating = false;
    this.start();
  }
}

Sculpteo3DViewerUIThrobber.prototype.animate = function (deltaT) {
  if (this.animationImage) {
    this.setBackgroundImage(
      this.animationImage,
      this.animationImageFrame * this.frame.w,
      0
    );
  }

  this.animationImageFrame++;
  this.animationImageFrame %= this.animationFrames;
};

Sculpteo3DViewerUIThrobber.prototype.start = function () {
  if (this.animating) {
    return;
  }

  this.animating = true;
  var startTime = +new Date();
  var that = this;

  this.animationImageFrame = 0;
  this.animationTimeout = setInterval(function () {
    that.animate.call(that, +new Date() - startTime);
  }, 1000 / this.fps);
};

Sculpteo3DViewerUIThrobber.prototype.stop = function () {
  this.animating = false;
  clearInterval(this.animationTimeout);
};

// Parser for easier UI coding
function Sculpteo3DViewerUIParser(viewer) {
  this.viewer = viewer;
  this.styles = {};
  this.elements = {};
}

Sculpteo3DViewerUIParser.prototype.parse = function (xml) {
  var xmlDoc = $.parseXML(xml);
  var $xml = $(xmlDoc);

  this.styles = {};
  this.elements = {};
  var parser = {
    style: Sculpteo3DViewerUIParser.prototype.parseStyle,
    label: Sculpteo3DViewerUIParser.prototype.parseLabel,
    layer: Sculpteo3DViewerUIParser.prototype.parseLayer,
    button: Sculpteo3DViewerUIParser.prototype.parseButton,
    togglebutton: Sculpteo3DViewerUIParser.prototype.parseToggleButton,
    slider: Sculpteo3DViewerUIParser.prototype.parseSlider,
  };

  var that = this;

  $xml
    .children()
    .children()
    .each(function (idx) {
      var el = this;

      p = parser[el.tagName];

      if (p) {
        p.call(that, el);
      } else {
        log("unrecognized ui tag " + el.tagName);
      }
    });
};

// Parse a style from CSS like format to UI internal format
Sculpteo3DViewerUIParser.prototype.parseStyle = function (el) {
  var $el = $(el);
  var id = $el.attr("id");

  if (!id) {
    log("missing id on style tag");

    return;
  }

  var stylelines = $el.text().split(";");
  var style = {};

  for (var i = 0; i < stylelines.length; i++) {
    var s = $.trim(stylelines[i]).split(":");

    if (s.length != 2) {
      continue;
    }

    var k = $.trim(s[0]);
    var v = $.trim(s[1]);

    if (v.startsWith("rgba(")) {
      // Convert color
      var t = v.replace("rgba(", "").replace(")", "").split(",");

      v = {
        r: $.trim(t[0]),
        g: $.trim(t[1]),
        b: $.trim(t[2]),
        a: $.trim(t[3]),
      };
    }

    // Convert key to camel case
    var ks = k.split("-");

    for (var j = 1; j < ks.length; j++) {
      ks[j] = ks[j][0].toUpperCase() + ks[j].substr(1);
    }

    k = ks.join("");

    style[k] = v;
  }

  this.styles[id] = style;
};

Sculpteo3DViewerUIParser.prototype.parseUIElement = function (el, f, attrs) {
  var $el = $(el);
  var id = $el.attr("id");

  if (!id) {
    log("missing id on ui element tag");

    return;
  }

  var data = { text: $.trim($el.text()) };

  // Get style reference; TODO: handle inline styles
  var styleref;

  styleref = $(el).attr("style");

  if (styleref && styleref[0] == "@" && this.styles[styleref.substr(1)]) {
    $.extend(data, this.styles[styleref.substr(1)]);
  }

  styleref = $(el).attr("highlight-style");

  if (styleref && styleref[0] == "@" && this.styles[styleref.substr(1)]) {
    $.extend(data, { highlightStyle: this.styles[styleref.substr(1)] });
  }

  styleref = $(el).attr("disabled-style");

  if (styleref && styleref[0] == "@" && this.styles[styleref.substr(1)]) {
    $.extend(data, { disabledStyle: this.styles[styleref.substr(1)] });
  }

  if (attrs) {
    for (var k = 0; k < attrs.length; k++) {
      var val = $(el).attr(attrs[k]);

      if (typeof val != "undefined") {
        data[attrs[k]] = val;
      }
    }
  }

  var element = f.call(this.viewer, data);

  this.elements[id] = element;
};

Sculpteo3DViewerUIParser.prototype.parseLayer = function (el) {
  this.parseUIElement(el, this.viewer.createUILayer);
};

Sculpteo3DViewerUIParser.prototype.parseLabel = function (el) {
  this.parseUIElement(el, this.viewer.createUILabel);
};

Sculpteo3DViewerUIParser.prototype.parseButton = function (el) {
  this.parseUIElement(el, this.viewer.createUIButton);
};

Sculpteo3DViewerUIParser.prototype.parseToggleButton = function (el) {
  this.parseUIElement(el, this.viewer.createUIToggleButton);
};

Sculpteo3DViewerUIParser.prototype.parseSlider = function (el) {
  this.parseUIElement(el, this.viewer.createUISlider, ["value"]);
};

Sculpteo3DViewerUIParser.prototype.getElementById = function (id) {
  return this.elements[id];
};

Sculpteo3DViewerUIParser.prototype.getStyleById = function (id) {
  return this.styles[id];
};

Sculpteo3DViewerUIParser.prototype.loadFromDOMElementById = function (id) {
  return this.parse(document.getElementById(id).innerHTML);
};

Sculpteo3DViewerUIThkMinOverlay = function (layer, viewerUI, desc, max, x, y) {
  this.panel = layer;
  var w = 110;
  var h = 30 * 10 + 50;

  this.panel.setFrame(x, y, w, h);
  this.desc = desc;
  var wt = desc.frame.w;

  this.desc.setFrame((w - wt) / 2, 30);
  this.panel.appendChild(this.desc);
  this.max = max;
  this.viewerUI = viewerUI;

  // This.w = w;
  // this.h = h;
  this.all = new Sculpteo3DViewerUIButton(this.panel.viewer, {
    textHeight: 15,
    text: gettext("All"),
  });
  this.all.setFrame(20, 50, 65, 25);
  this.all.highlightStyle.frame = { x: 20, y: 50, w: 65, h: 25 };
  var xMargin = (this.all.frame.w - this.all.textLayer.frame.w) / 2;
  var yMargin = (this.all.frame.h - this.all.textLayer.frame.h) / 2;

  this.all.textLayer.setFrame(xMargin, yMargin);
  this.all.setText = function (str, options) {
    var f = this.textLayer.frame;
    var r = this.textLayer.setText(str, options);

    this.textLayer.setFrame(f.x, f.y);

    return r;
  };

  this.all.activated = false;
  var _this = this;

  this.all.cnt = 0;
  this.all.addEventListener("click", function () {
    if (!this.activated) {
      _this.highlightAll();
      this.activated = true;
      this.cnt = _this.len;
    } else {
      _this.downlightAll();
      this.activated = false;
      this.cnt = 0;
    }

    this.update(0);
  });

  this.all.update = function (up) {
    this.cnt += up;

    if (this.cnt == _this.len) {
      this.setBackgroundColor(192, 0, 0, 192);
      this.activated = true;
    } else if (this.cnt == 0) {
      this.setBackgroundColor(0, 0, 0, 192);
      this.activated = false;
    } else {
      this.setBackgroundColor(96, 0, 0, 192);
    }
  };

  this.all.up = function () {
    this.update(1);
  };

  this.all.down = function () {
    this.update(-1);
  };

  this.all.reset = function () {
    this.cnt = 0;
    this.update(0);
  };

  this.panel.appendChild(this.all);
};

Sculpteo3DViewerUIThkMinOverlay.prototype.getChildren = function () {
  return this.panel.childLayers.slice(2);
};

Sculpteo3DViewerUIThkMinOverlay.prototype.cleanUp = function () {
  var i;
  var array = this.getChildren();

  for (i = 0; i < array.length; i++) {
    var e = array[i];

    e.removeEventListener("mousedown");

    // If(e.container) e.container.detach();
    e.deactivate();
    e.detach();
  }

  this.panel.detach();
};

Sculpteo3DViewerUIThkMinOverlay.prototype.highlightAll = function () {
  this.getChildren().map(function (e) {
    if (e.activate) {
      e.activate();
    }
  });
};

Sculpteo3DViewerUIThkMinOverlay.prototype.downlightAll = function () {
  this.getChildren().map(function (e) {
    if (e.deactivate) {
      e.deactivate();
    }
  });
};

Sculpteo3DViewerUIThkMinOverlay.prototype.update = function (
  data,
  root,
  callback
) {
  if (!data.minima || data.minima.length == 0) {
    return;
  }

  var self = this;

  this.all.reset();
  var i;
  var array = this.getChildren();

  this.len = Math.min(data.minima.length, this.max);
  root.appendChild(this.panel);

  for (i = 0; i < this.len; i++) {
    var a;
    var name;

    if (i < array.length) {
      a = array[i];
      name = a.text;
    } else {
      // Name = 'Point ' + (i+1);
      name = i + 1;
      a = new Sculpteo3DViewerUIButton(this.panel.viewer, {
        textHeight: 15,
        text: name,
      });
      a.setText = function (str, options) {
        var f = this.textLayer.frame;
        var r = this.textLayer.setText(str, options);

        this.textLayer.setFrame(f.x, f.y);

        return r;
      };

      a.setFrame(
        35 * (i % 2) + 20,
        30 * Math.round(i / 2 - 0.001) + 80,
        30,
        25
      );
      a.highlightStyle.frame = {
        x: 35 * (i % 2) + 20,
        y: 30 * Math.round(i / 2 - 0.001) + 80,
        w: 30,
        h: 25,
      };
      var xMargin = (a.frame.w - a.textLayer.frame.w) / 2;
      var yMargin = (a.frame.h - a.textLayer.frame.h) / 2;

      a.textLayer.setFrame(xMargin, yMargin);
      this.panel.appendChild(a);
      a.name = name;
    }

    var coord_array = data.minima[i].slice();
    var coord = {
      x: coord_array[0],
      y: coord_array[1],
      z: coord_array[2],
      e: coord_array[3],
    };

    a.op_coord = coord_array[4];
    a.vec = coord_array[5];
    var viewerUI = this.viewerUI;

    a.params = {
      x: coord.x,
      y: coord.y,
      z: coord.z,
      e: coord.e,
      type: "add",
      state: 0,
      dx: 0,
      dy: 0,
      dz: 0,
    };
    a.activate = function () {
      if (!this.container) {
        this.container = viewerUI.draw_wall_thickness(
          {
            thickness: this.params.e,
            distance: 1.0,
            pos: this.op_coord,
          },
          this.params,
          this.name + gettext(" - thickness: ")
        );
      }

      this.setBackgroundColor(192, 0, 0, 192);
      this.activated = true;
      this.container.removeEventListener("click");
      self.all.up();
      var _this = this;

      this.container.click(function () {
        _this.deactivate();
      });

      return this.container;
    };

    a.deactivate = function () {
      this.setBackgroundColor(0, 0, 0, 192);
      self.all.down();

      if (this.container) {
        this.container.remove();
      }

      this.container = undefined;
      this.activated = false;
    };

    // Var normal = {
    // x: coord_array[4],
    // y: coord_array[5],
    // z: coord_array[6],
    // e: coord_array[3],
    // }
    callback(coord, undefined, a, "mousedown", name);
  }
};

Sculpteo3DViewerUIThkMinOverlay.prototype.detach = function () {
  this.panel.detach();
};
